/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, MouseEvent, useEffect, useState, BaseSyntheticEvent } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Button } from '../../../components/Button/Button'
import { Input } from '../../../components/Input/Input'
import { useNavigate } from 'react-router-dom'
import { Loading } from '../../../components/Loading/Loading'
import { POST, PUT } from '../../../services/api'
import Swal from 'sweetalert2'
import { i18n } from '../../../translate/i18n'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import uuid from 'react-uuid'
import moment from 'moment-timezone'

enum typeBannerHotel {
  BANNER = 'banner',
  HIGHLIGHT = 'highlight',
}
interface CreatePublicityHotelDto {
  image?: string
  order: number
  title: string
  type: typeBannerHotel
  startDate: string
  endDate: string
  description: string
  externalLink?: string
  status?: boolean
}

const ContaContent: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  // Form state
  const [formData, setFormData] = useState<CreatePublicityHotelDto>({
    image: '',
    title: '',
    order: 1,
    startDate: '',
    type: typeBannerHotel.HIGHLIGHT,
    externalLink: '',
    description: '',
    endDate: '',
    status: true,
  })
  const [image, setImage] = useState<File | null>(null)
  // Separate date and time states for better UX
  const [hasExternalLink, setHasExternalLink] = useState(false)
  const [startDateOnly, setStartDateOnly] = useState('')
  const [startTimeOnly, setStartTimeOnly] = useState('00:00:00')
  const [endDateOnly, setEndDateOnly] = useState('')
  const [endTimeOnly, setEndTimeOnly] = useState('23:59:59')
  // Handle input changes


  const handleInputChange = (field: keyof CreatePublicityHotelDto, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  // Update combined datetime when date or time changes
  useEffect(() => {
    if (startDateOnly && startTimeOnly) {
      setFormData(prev => ({
        ...prev,
        startDate: moment(`${startDateOnly}T${startTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss')
      }))
    }
  }, [startDateOnly, startTimeOnly])

  useEffect(() => {
    if (endDateOnly && endTimeOnly) {
      setFormData(prev => ({
        ...prev,
        endDate: moment(`${endDateOnly}T${endTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss')
      }))
    }
  }, [endDateOnly, endTimeOnly])

  const validateForm = (): boolean => {
    if (!formData.order || formData.order <= 0) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.order_positive')),
      })
      return false
    }

    if (!startDateOnly) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.start_date_required')),
      })
      return false
    }

    if (!endDateOnly) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.end_date_required')),
      })
      return false
    }

    if (!formData.startDate || !formData.endDate) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.dates_required')),
      })
      return false
    }

    // Validação das datas
    const startDateTime = moment(`${formData.startDate}`, 'YYYY-MM-DD HH:mm:ss', true)
    const endDateTime = moment(`${formData.endDate}`, 'YYYY-MM-DD HH:mm:ss', true)

    if (endDateTime.isSameOrBefore(startDateTime)) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.start_before_end')),
      })
      return false
    }


    if (hasExternalLink && !formData.externalLink) {
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.validation.title')),
        text: String(i18n.t('hospitality_publicity_create.validation.external_link_required')),
      })
      return false
    }

    return true
  }



  const createPublicidade = async () => {
    if (!validateForm()) return

    try {
      setLoading(true)

      let imageRes = {
        success: false,
        image: '',
      }

      // Preparar dados para envio
      const dataToSend: CreatePublicityHotelDto = {
        order: formData.order,
        title: formData.title,
        startDate: moment(`${formData.startDate}`).format(`YYYY-MM-DD HH:mm:ss`),
        endDate: moment(`${formData.endDate}`).format(`YYYY-MM-DD HH:mm:ss`),
        type: typeBannerHotel.HIGHLIGHT,
        description: formData.description,
        externalLink: formData.externalLink,
        status: formData.status,
        image: imageRes.success ? imageRes.image : 'default/no-image.png',
      }


      const response = await POST('/publicity-hotel', dataToSend)

      if (response.success) {
        try {
          if (image) {
            const formData = new FormData()
            formData.append('file', image)
            formData.append('nameImage', `publicity-${uuid()}.jpg`)
            formData.append('originalSize', 'true')
            imageRes = await POST('/upload-images/upload-one', formData)
            if (imageRes.success) {
              await PUT(`/publicity-hotel/${response.data.id}`, {
                image: imageRes.image,
              })
            }
          }
        } catch (error) {

        }
      }

      if (response.success) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_publicity_create.success.title')),
          text: String(i18n.t('hospitality_publicity_create.success.text')),
        }).then(() => navigate('/hospitality/publicity'))
      } else {
        throw new Error(response.message || 'Erro ao criar publicidade')
      }

      setLoading(false)
    } catch (error: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_publicity_create.error.title')),
        text: String(error.message || i18n.t('hospitality_publicity_create.error.text')),
      })
      console.error(error)
    }
  }

  const resizeImage = (file: File, targetWidth: number, targetHeight: number): Promise<File> => {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')!
        const img = new Image()
  
        img.onload = () => {
          const { naturalWidth: width, naturalHeight: height } = img
  
          // Calcular o crop centralizado
          const sourceRatio = width / height
          const targetRatio = targetWidth / targetHeight
  
          let sourceWidth, sourceHeight, sourceX, sourceY
  
          if (sourceRatio > targetRatio) {
            // Imagem mais larga - cortar nas laterais
            sourceHeight = height
            sourceWidth = height * targetRatio
            sourceX = (width - sourceWidth) / 2
            sourceY = 0
          } else {
            // Imagem mais alta - cortar em cima e embaixo
            sourceWidth = width
            sourceHeight = width / targetRatio
            sourceX = 0
            sourceY = (height - sourceHeight) / 2
          }
  
          // Configurar canvas
          canvas.width = targetWidth
          canvas.height = targetHeight
  
          // Desenhar imagem redimensionada e cortada no centro
          ctx.drawImage(
            img,
            sourceX, sourceY, sourceWidth, sourceHeight,
            0, 0, targetWidth, targetHeight
          )
  
          // Converter canvas para blob e depois para File
          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now()
              })
              resolve(resizedFile)
            }
          }, file.type, 0.9)
        }
  
        img.src = URL.createObjectURL(file)
      })
    }
  
    const validateImage = (file: File): Promise<File | null> => {
      return new Promise((resolve) => {
        // Verificar tamanho do arquivo (máximo 2MB)
        const maxSizeInBytes = 2 * 1024 * 1024 // 2MB
        if (file.size > maxSizeInBytes) {
          Swal.fire({
            icon: 'warning',
            title: String(i18n.t('hospitality_publicity_create.validation.title')),
            text: String(i18n.t('hospitality_publicity_create.validation.image_size_error')),
          })
          resolve(null)
          return
        }
  
        // Verificar dimensões da imagem
        const img = new Image()
        img.onload = async () => {
          const width = img.naturalWidth
          const height = img.naturalHeight
          
          // Dimensões esperadas: aproximadamente 720x600 (tolerância de ±10%)
          const expectedWidth = 720
          const expectedHeight = 600
          const tolerance = 0.1 // 10%
          
          const minWidth = expectedWidth * (1 - tolerance)
          const maxWidth = expectedWidth * (1 + tolerance)
          const minHeight = expectedHeight * (1 - tolerance)
          const maxHeight = expectedHeight * (1 + tolerance)
          
          if (width < minWidth || width > maxWidth || height < minHeight || height > maxHeight) {
            // Perguntar se o usuário quer redimensionar
            const result = await Swal.fire({
              icon: 'question',
              title: String(i18n.t('hospitality_publicity_create.validation.title')),
              html: `
                <p>${String(i18n.t('hospitality_publicity_create.validation.image_dimensions_error', {
                  current: `${width}x${height}`,
                  expected: `${expectedWidth}x${expectedHeight}`
                }).replace('200x112', `${expectedWidth}x${expectedHeight}`))}</p>
                <p><strong>Deseja redimensionar a imagem automaticamente?</strong></p>
                <p><small>A imagem será cortada no centro para se ajustar às dimensões necessárias.</small></p>
              `,
              showCancelButton: true,
              confirmButtonText: 'Sim, redimensionar',
              cancelButtonText: 'Não, escolher outra imagem',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            })
  
            if (result.isConfirmed) {
              try {
                const resizedFile = await resizeImage(file, expectedWidth, expectedHeight)
                resolve(resizedFile)
              } catch (error) {
                Swal.fire({
                  icon: 'error',
                  title: 'Erro',
                  text: 'Ocorreu um erro ao redimensionar a imagem. Tente novamente.',
                })
                resolve(null)
              }
            } else {
              resolve(null)
            }
            return
          }
          
          resolve(file)
        }
        
        img.onerror = () => {
          Swal.fire({
            icon: 'warning',
            title: String(i18n.t('hospitality_publicity_create.validation.title')),
            text: String(i18n.t('hospitality_publicity_create.validation.image_invalid')),
          })
          resolve(null)
        }
        
        img.src = URL.createObjectURL(file)
      })
    }

  if (loading) return <Loading />

  return (
    <>

      <div className='card py-4 px-11'>
        <div className='row'>
          <div>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t('hospitality_publicity_create.page_title')}</span>
              <BreadCrumbs />
              <span className='text-muted mt-1 fw-bold fs-7'>
                {i18n.t('hospitality_publicity_create.page_subtitle')}
              </span>
            </h3>
          </div>

          <div className='col-12 mt-8'>
            <div className='row'>
              {/* Ordem e Status */}
              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'number',
                    min: '1',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.order_label')}
                  placeholder={i18n.t('hospitality_publicity_create.form.order_placeholder')}
                  value={formData.order.toString()}
                  change={(value: string) => handleInputChange('order', parseInt(value) || 1)}
                  smalltext={i18n.t('hospitality_publicity_create.form.order_smalltext')}
                  required
                />
              </div>

              <div className='col-md-6 d-flex align-items-end'>
                <Input
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.status_label')}
                  checked={formData.status}
                  change={(checked: boolean) => handleInputChange('status', checked)}
                  checkSwift
                  smalltext={i18n.t('hospitality_publicity_create.form.status_smalltext')}
                />
              </div>
            </div>

            {/* Datas */}
            <div className='row mt-4'>
              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'date',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.start_date_label')}
                  value={startDateOnly}
                  change={(value: string) => setStartDateOnly(value)}
                  required
                  minLength={new Date().toISOString().split('T')[0]} // Data atual ou futura
                />
              </div>

              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'time',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.start_time_label')}
                  value={startTimeOnly}
                  change={(value: string) => setStartTimeOnly(value)}

                  required
                />
              </div>
            </div>

            <div className='row mt-4'>
              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'date',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.end_date_label')}
                  value={endDateOnly}
                  change={(value: string) => setEndDateOnly(value)}
                  minLength={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>

              <div className='col-md-6'>
                <Input
                  inputAttr={{
                    type: 'time',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.end_time_label')}
                  value={endTimeOnly}
                  change={(value: string) => setEndTimeOnly(value)}
                  required
                />
              </div>
            </div>

            {/* Preview das datas */}
            {formData.startDate && formData.endDate && (
              <div className='row mt-3'>
                <div className='col-12'>
                  <div className='alert alert-info'>
                    <h6 className='mb-2'>📅 {i18n.t('hospitality_publicity_create.preview.period_title')}</h6>
                    <p className='mb-1'>
                      <strong>{i18n.t('hospitality_publicity_create.preview.start')}:</strong> {new Date(formData.startDate).toLocaleString('pt-BR')}
                    </p>
                    <p className='mb-0'>
                      <strong>{i18n.t('hospitality_publicity_create.preview.end')}:</strong> {new Date(formData.endDate).toLocaleString('pt-BR')}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Link Externo */}
            <div className='row mt-4'>
              <div className='col-12'>
                <Input
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.external_link_checkbox')}
                  checked={hasExternalLink}
                  change={(checked: boolean) => {
                    setHasExternalLink(checked)
                    if (!checked) {
                      handleInputChange('externalLink', '')
                    }
                    if (checked) {
                      handleInputChange('description', formData.description.substring(0, 250))
                    }
                  }}
                  checkSwift
                />
                {hasExternalLink && (
                  <div className='mt-3'>
                    <Input
                      inputAttr={{
                        type: 'text',
                        placeholder: 'https://example.com',
                      }}
                      label={i18n.t('hospitality_publicity_create.form.external_link_label')}
                      placeholder={i18n.t('hospitality_publicity_create.form.external_link_placeholder')}
                      value={formData.externalLink}
                      change={(value: string) => {
                        handleInputChange('externalLink', value)

                      }}
                      required
                      maxCaracteres={250}
                    />
                  </div>
                )}

              </div>
            </div>

            {/* Descrição */}
            <div className='row mt-4'>
               <div className='col-12'>
                <Input
                  inputAttr={{
                    type: 'default',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.title_label')}
                  value={formData.title}
                  change={(value: string) => handleInputChange('title', value)}
                  maxCaracteres={100}
                />
              </div>
              <div className='col-12'>
                <Input
                  inputAttr={{
                    type: 'textarea',
                  }}
                  label={i18n.t('hospitality_publicity_create.form.description_label')}
                  value={formData.description}
                  change={(value: string) => handleInputChange('description', value)}
                  maxCaracteres={hasExternalLink ? 250 : 600}
                  rows={4}
                  smalltext={i18n.t('hospitality_publicity_create.form.description_smalltext').replace('{qtd}', hasExternalLink ? '250' : '600')}
                />
              </div>
            </div>

            {/* Upload de Imagem */}
            <div className='row mt-6'>
              <div className='col-md-6'>
                <div className='mb-4'>
                  <label className='form-label fw-bold'>{i18n.t('hospitality_publicity_create.form.image_label')}</label>
                  <div className='border border-dashed border-primary p-6 text-center rounded'>

                    {image ? (<>
                      <img
                        className='w-25 h-100 rounded mb-2'
                        src={image ? URL.createObjectURL(image) : ''}
                        alt=''
                      />
                    </>) : (<i className='fas fa-cloud-upload-alt fa-3x text-primary mb-3'></i>)

                    }

                    <h6 className='mb-2'>{i18n.t('hospitality_publicity_create.form.image_select')}</h6>
                    <p className='text-muted mb-3'>{i18n.t('hospitality_publicity_create.form.image_formats')}</p>
                    <input
                      type='file'
                      accept='.jpg, .jpeg, .png, .gif'
                      onChange={async (value: React.BaseSyntheticEvent) => {
                        const file = value.target.files[0]
                        if (file) {
                          const isValid = await validateImage(file)
                          if (isValid) {
                            setImage(file)
                          } else {
                            // Limpar o input se a imagem não for válida
                            value.target.value = ''
                          }
                        }
                      }}
                      className='form-control'
                    />
                    <small className='text-muted'>{i18n.t('hospitality_publicity_create.form.image_optional')}</small>
                  </div>
                </div>
              </div>

              <div className='col-md-6'>
                {formData.image && (
                  <div className='text-center'>
                    <label className='form-label fw-bold'>{i18n.t('hospitality_publicity_create.form.image_preview')}</label>
                    <div className='border rounded p-3'>
                      <img
                        src={formData.image}
                        alt='Preview'
                        className='img-fluid rounded'
                        style={{ maxHeight: '200px', width: 'auto' }}
                      />
                      <div className='mt-2'>
                        <button
                          type='button'
                          className='btn btn-sm btn-light-danger'
                          onClick={() => handleInputChange('image', '')}
                        >
                          <i className='fas fa-trash me-1'></i>
                          {i18n.t('hospitality_publicity_create.form.image_remove')}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Botões de Ação */}
        <div className='d-flex justify-content-between pt-8 mt-8 border-top'>
          <Button
            text={i18n.t(`buttons.back`)}
            color='secondary'
            size='small'
            horizontalPadding={6}
            btnAttr={{
              type: 'button',
            }}
            click={() => navigate('/hospitality/publicity')}
            btnClass='fw-bolder'
          />
          <Button
            text={i18n.t(`buttons.save`)}
            color='primary'
            size='small'
            horizontalPadding={5}
            btnAttr={{
              type: 'button',
            }}
            click={createPublicidade}
            btnClass='fw-bolder'
            disabled={loading}
          />
        </div>
      </div>
    </>
  )
}

const CriarPublicidadeHotel: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: false },
          { title: i18n.t('hospitality_publicity_create.breadcrumb.hospitality'), path: 'hospitality', isActive: false },
          { title: i18n.t('hospitality_publicity_create.breadcrumb.publicity'), path: 'hospitality/publicity', isActive: false },
          { title: i18n.t('hospitality_publicity_create.breadcrumb.create'), path: 'hospitality/publicity/create', isActive: true },
        ]}
      >
        {i18n.t('hospitality_publicity_create.page_title')}
      </PageTitle>
      <ContaContent />
    </>
  )
}

export { CriarPublicidadeHotel }
